import { adminBenchmarksEndpoints, adminBenchmarksQueryParams } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiBenchmarkListItemHandler } from "@/services/shared";
import type {
    ApiBenchmarkListItemType,
    BenchmarksPageType,
    ListBenchmarksParamsType,
} from "@/types";

interface ApiBenchmarksListEnvelopeInterface {
    data?: {
        current_page?: number, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case
        data?: ApiBenchmarkListItemType[],
        last_page?: number, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case
        per_page?: number, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case
        total?: number,
    },
    success?: boolean,
}

export const listBenchmarksByEndpointHandler = async (endpoint: string, params: ListBenchmarksParamsType = {}): Promise<BenchmarksPageType> => {
    const queryParams: Record<string, number | string> = { page: params.page ?? 1 };

    if (params.perPage) queryParams[adminBenchmarksQueryParams.perPage] = params.perPage;

    if (params.industry) queryParams[adminBenchmarksQueryParams.industry] = params.industry;

    if (params.jobTitle) queryParams[adminBenchmarksQueryParams.jobTitle] = params.jobTitle;

    const response = await axiosClient.get<ApiBenchmarksListEnvelopeInterface>(
        endpoint,
        { params: queryParams },
    );

    const paginator = response.data.data;

    const items = (paginator?.data ?? []).map(transformApiBenchmarkListItemHandler);

    return {
        currentPage: paginator?.current_page ?? 1,
        items,
        lastPage: paginator?.last_page ?? 1,
        perPage: paginator?.per_page ?? items.length,
        total: paginator?.total ?? items.length,
    };
};

export const listAdminBenchmarksHandler = (params: ListBenchmarksParamsType = {}): Promise<BenchmarksPageType> => listBenchmarksByEndpointHandler(
    adminBenchmarksEndpoints.base,
    params,
);
